<template>
  <div class="container content-p">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="cohortSummary === undefined">
      <h4 class="alert-heading">Error fetching cohort data</h4>
      <div class="alert-body">
        No cohort found with this cohort id. Check
        <b-link class="alert-link" :to="{ name: 'apps-accounting-receivable-cohort-list-pending' }"> Cohort List </b-link>
        for other cohorts.
      </div>
    </b-alert>

    <b-row class="mb-1">
      <b-col cols="12">
        <cohort-view-cohort-info-card v-if="cohortSummary.cohort.id" :cohort-summary.sync="cohortSummary" />
      </b-col>
    </b-row>

    <b-row class="mb-50">
      <b-col md="12" lg="7">
        <cohort-statistics :cohort-summary="cohortSummary" type="s1"></cohort-statistics>
      </b-col>
      <b-col md="12" lg="5">
        <cohort-statistics :cohort-summary="cohortSummary" type="s2"></cohort-statistics>
      </b-col>
    </b-row>

    <!-- First Row -->
    <b-row>
      <b-col cols="12">
        <cohort-account-list @refresh="loadCohortSummary" :cohort-data="cohortSummary.cohort"></cohort-account-list>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import store from '@/store';
import router from '@/router';
import { ref, onUnmounted } from '@vue/composition-api';
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BTable,
  BFormInput,
  BButton,
  BCard,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BDropdownDivider,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import CohortViewCohortInfoCard from './CohortViewUserInfoCard.vue';
import useCohortAccountsList from './useCohortAccountsList';
import CohortAccountList from '@/views/apps/accounting/receivable/cohort/view/CohortAccountList.vue';
import CohortStatistics from '@/views/apps/accounting/receivable/cohort/view/CohortStatistics.vue';

export default {
  components: {
    CohortStatistics,
    CohortAccountList,
    BRow,
    BCol,
    BAlert,
    BLink,
    BTable,

    BCard,
    BFormInput,
    BButton,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BDropdownDivider,

    vSelect,

    // Local Components
    CohortViewCohortInfoCard,
  },
  methods: {
    loadCohortSummary() {
      this.$store
        .dispatch('receivableStoreModule/fetchCohortSummary', {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          this.cohortSummary = response.data;
          console.log(`cohort`, response.data);
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.cohortSummary = undefined;
          }
        });
    },
  },
  mounted() {
    this.loadCohortSummary();
  },
  setup() {
    const cohortSummary = ref({ cohort: {}, meta: {} });

    const {
      fetchPathwayCohorts,
      tableColumns,
      perPage,
      currentPage,
      totalSessions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPathwayCohortListTable,
      refetchData,

      statusOptions,

      // UI
      resolveSessionVisibilityVariant,
      resolveSessionStatusVariant,

      // Extra Filters
      visibilityFilter,
      statusFilter,
    } = useCohortAccountsList(cohortSummary);

    return {
      cohortSummary,

      fetchPathwayCohorts,
      tableColumns,
      perPage,
      currentPage,
      totalSessions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPathwayCohortListTable,
      refetchData,

      statusOptions,

      // UI
      resolveSessionVisibilityVariant,
      resolveSessionStatusVariant,

      // Extra Filters
      visibilityFilter,
      statusFilter,
    };
  },
};
</script>

<style></style>
